<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form :model="querys" ref="querys" label-width="90px" class="search-form">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col>
            <el-input v-model="querys.keyword" prefix-icon="Search" @change="fetchs()"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="所属公司" prop="companyID">
          <el-tree-select v-model="companyID" :data="companys"
            @change="departmentID = ''; companyChange(companyID); fetchs()" check-strictly :render-after-expand="false"
            style="min-width: 220px;" clearable />
        </el-form-item>

        <el-form-item label="所属部门" prop="departmentID">
          <el-tree-select v-model="departmentID" :data="departments" check-strictly @change="fetchs()"
            style="min-width: 120px;" :render-after-expand="false" clearable />
        </el-form-item>

        <el-form-item label="账户状态" prop="isEnabled">
          <!-- <el-switch v-model="isEnabled" active-color="#13ce66" inactive-color="#ff4949" active-text="启用"
            inactive-text="禁用" @change="fetchs()"></el-switch> -->
          <el-select v-model="isEnabled" clearable placeholder="" @change="fetchs()" style="min-width: 80px;">
            <el-option key="1" label="启用" value="1"></el-option>
            <el-option key="0" label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="" label-width="20px">
          <el-button type="primary" icon="search" @click="fetchs()"> 搜索 </el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="primary" icon="plus" @click="add()">新增</el-button>
      <el-button type="danger" icon="delete" @click="del()">删除</el-button>
      <el-button type="success" icon="Refresh" @click="reset()">重置密码</el-button>
      <el-button type="warning" icon="Lock" @click="resetSecondaryPassword()">重置安全密码</el-button>

      <el-button plain icon="Download" @click="fetchs('Export')">导出</el-button>
    </div>

    <basic-table class="table"  :query="querys" @handler="fetchs" :currHandler="currHandler">
      <template v-slot:toolbar="scope">
        <el-button @click="edit(scope.row)" link size="small" type="primary">[编辑]</el-button>
        <el-button @click="openRole(scope.row)" link size="small" type="primary">[角色]</el-button>
        <el-button @click="openCompanyPower(scope.row)" link size="small" type="primary">[公司权限]</el-button>
      </template>
      <template v-slot:isEnabled="scope">
        <el-switch v-model="scope.row.isEnabled" active-color="#13ce66" inactive-color="#ff4949" active-text=""
          inactive-text="" :disabled="true">
        </el-switch>
      </template>
      <template v-slot:birthday="scope">
        <el-icon v-show="scope.row.birthday">
          <Calendar />
        </el-icon>
        <span style="margin-left: 10px">{{ (scope.row.birthday || "").split(" ")[0] }}</span>
      </template>
    </basic-table>
  </el-card>

  <static-dialog ref="dialog" class="dialog" title="用户维护" :opened="opened" :ok="submit">
    <el-form :model="forms" :rules="rules" ref="forms" :label-width="labelWidth">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="所属公司" prop="companyID">
            <el-tree-select v-model="forms.companyID" :data="companys"
              @change="forms.departmentID = ''; companyChange(forms.companyID)" check-strictly
              :render-after-expand="false" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="所属部门" prop="departmentID">
            <!-- <el-select v-model="forms.parentID" placeholder="请选择上级菜单" disabled>
              <el-option label="根菜单" value=""></el-option>
            </el-select> -->
            <el-tree-select v-model="forms.departmentID" :data="departments" check-strictly
              :render-after-expand="false" />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="用户账户" prop="account">
            <el-input v-model="forms.account" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="姓名" prop="realName">
            <el-input v-model="forms.realName" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="forms.mobile" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="生日">
            <el-date-picker v-model="forms.birthday" type="date" placeholder="选择生日" format="YYYY-MM-DD"
              :editable="false">
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="!forms.id">
          <el-form-item label="密码" prop="password">
            <el-input v-model="forms.password" placeholder="默认账户密码，登录时修改" autocomplete="off" show-password
              disabled></el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="性别" class="gender">
            <el-radio v-model="forms.gender" label="男">男</el-radio>
            <el-radio v-model="forms.gender" label="女">女</el-radio>
            <el-radio v-model="forms.gender" label="无">无</el-radio>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="状态">
            <el-switch v-model="forms.isEnabled" active-color="#13ce66" inactive-color="#ff4949" active-text="启用"
              inactive-text="禁用" style="margin-left: 10px">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="排序号">
            <el-input-number v-model="forms.sortCode" :min="1" :max="9999999" label="排序号"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </static-dialog>

  <static-dialog ref="resetDialog" class="dialog" title="重置密码" :ok="resetPwdEvent">
    <resetPwdDialog :visible="true" :user="currRow" ref="resetPwdDialogRef"></resetPwdDialog>
  </static-dialog>

  <static-dialog ref="roleDialog" width="900px" class="dialog" title="用户角色分配" :ok="submitRole">
    <roleSelect ref="roleSelect"></roleSelect>
  </static-dialog>

  <static-dialog ref="companyPowerDialog" width="900px" class="dialog" title="用户公司权限" :ok="submitCompanyPower">
    <el-scrollbar style="height: 45vh; width:30%;">
      <el-tree ref="companyPowerTree" :data="companyTreeData" show-checkbox node-key="value" :check-strictly="true" :check-on-click-node="true" default-expand-all
        :props="companyTreeProps">
      </el-tree>
    </el-scrollbar>
  </static-dialog>

  <!-- 重置安全密码对话框 -->
  <el-dialog
    v-model="secondaryPasswordDialog"
    title="重置安全密码"
    width="500px"
    :close-on-click-modal="false">
    <el-alert
      :title="`为用户「${currRow?.realName || ''}」重置安全密码`"
      type="warning"
      :closable="false"
      show-icon
      style="margin-bottom: 20px;">
    </el-alert>
    
    <el-form ref="secondaryPasswordFormRef" :model="secondaryPasswordForm" :rules="secondaryPasswordFormRules" label-width="120px">
      <el-form-item label="旧安全密码" prop="oldPassword">
        <el-input
          v-model="secondaryPasswordForm.oldPassword"
          type="password"
          show-password
          autocomplete="off"
          placeholder=""
          clearable />
      </el-form-item>
      <el-form-item label="新安全密码" prop="newPassword">
        <el-input
          v-model="secondaryPasswordForm.newPassword"
          type="password"
          show-password
          autocomplete="new-password"
          placeholder="请输入新安全密码（不少于6位）"
          clearable />
      </el-form-item>
      <el-form-item label="确认新密码" prop="confirmNewPassword">
        <el-input
          v-model="secondaryPasswordForm.confirmNewPassword"
          type="password"
          show-password
          autocomplete="new-password"
          placeholder="请再次输入新安全密码"
          clearable />
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="secondaryPasswordDialog = false">取消</el-button>
        <el-button type="primary" @click="handleResetSecondaryPassword" :loading="submittingSecondaryPassword">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { fetchUsers, delUsers, submitUser, fetchRelationByGlobalId, submitRelationByGlobalId, submitUserDataRange, fetchUserDataRange } from "@/api/sys";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
import resetPwdDialog from "@/views/sys/user/reset.vue";
import roleSelect from "@/views/sys/role/select.vue";
export default {
  name: "User",
  components: { StaticDialog, BasicTable, resetPwdDialog, roleSelect },
  data() {
    // 自定义验证器：确认新密码
    const validateConfirmNewPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.secondaryPasswordForm.newPassword) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };

    return {
      querys: {
        keyword: "",
        columns: [
          { type: "index", label: "序号" },
          { type: 'hidden', prop: "companyID", label: "公司ID", sortable: true, width: "110", },
          { type: 'hidden', prop: "departmentID", label: "部门ID", sortable: true, width: "110", },
          { prop: "account", label: "账户", sortable: true, searchable: true, width: "110", },
          { prop: "realName", label: "姓名", width: "110", sortable: true, searchable: true, },
          { prop: "mobile", label: "手机号", sortable: true, searchable: true, width: "110", },
          { prop: "gender", label: "性别", width: "90", sortable: true, searchable: true, },
          { type: "template", prop: "birthday", label: "生日", sortable: true, width: "120", },
          { type: "template", prop: "isEnabled", label: "状态", sortable: true, width: "90", },
          { prop: "sortCode", label: "排序号", sortable: true, width: "100", },
          { prop: "loginDate", label: "最后登录时间", width: "180" },
          { prop: "createDate", label: "创建时间", width: "180" },
          { type: "toolbar", label: "操作", width: "180" },
        ],
        sidx: "loginDate",
        sord: "descending",
      },
      //multipleSelection: [], //多选的列
      currRow: null,

      forms: {},
      labelWidth: "90px",
      rules: {
        account: [
          { required: true, message: "请输入账户名称", trigger: "blur" },
        ],
        realName: [
          { required: true, message: "请输入用户姓名", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入账户手机号", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的手机号格式", trigger: "blur", },
        ],
        password: [
          { min: 4, max: 30, message: "密码长度不符合要求", trigger: "blur", },
        ],
      },

      isEnabled: null,
      companyID: '',
      departmentID: '',

      departments: [],
      companys: [],
      companyPowerId: '',
      companyTreeData: [],
      companyCheckedKeys: [],
      companyTreeProps: {
        children: "children",
        label: "label",
      },
      
      // 重置安全密码相关
      secondaryPasswordDialog: false,
      submittingSecondaryPassword: false,
      secondaryPasswordForm: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      secondaryPasswordFormRules: {
        oldPassword: [
          { required: true, message: '请输入旧安全密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新安全密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmNewPassword: [
          { required: true, validator: validateConfirmNewPassword, trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.fetchs();

    let that = this;
    this.$kaung.companys().then((res) => {
      that.companys = res;
      that.companyTreeData = res || [];
    });
  },
  methods: {
    //this.$refs.dialog.**
    edit(row) {
      this.forms = { ...row }; //JSON.parse(JSON.stringify(row));

      this.companyChange(this.forms.companyID);

      this.$refs.dialog.toggle();
    },
    add() {
      this.forms = { sortCode: 1, gender: "无" };

      this.$refs.dialog.toggle();
    },
    del() {
      let that = this;
      this.$confirm("此操作将删除本页选择数据, 是否继续?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
        .then(() => {
          delUsers(that.currRow.id).then((res) => {
            if (res.code === 200) {
              that.$message({
                type: "success",
                message: "删除成功",
              });
              that.fetchs();
            }
          });
        })
        .catch(() => {
          that.$message({ type: "info", message: "删除失败", });
        });
    },
    opened() {
      this.forms.sortCode = this.forms.sortCode || 1;
      this.forms.gender = this.forms.gender || "无";
      //懒渲染导致的BUG
      if (this.forms.birthday)
        this.forms.birthday = new Date(this.forms.birthday);
    },
    fetchs(methodName) {
      if ((typeof methodName) == 'object') methodName = null;
      //移除多余的参数
      //let { data, records, total, ...query } = { ...params };
      let { data, records, total, ...search } = {
        ...this.querys,
      };
      search.filters = [];
      if (this.companyID)
        search.filters.push({
          name: "companyId",
          value: this.companyID,
          operate: 0,
        });
      if (this.departmentID)
        search.filters.push({
          name: "departmentID",
          value: this.departmentID,
          operate: 0,
        });

      if (this.isEnabled)
        search.filters.push({
          name: "isEnabled",
          value: this.isEnabled,
          operate: 0,
        });

      search.method = methodName || '';
      fetchUsers(search).then((res) => {
        if (search.method == 'Export') {
          this.$notify({
            title: "导出成功",
            message: res.content,
            type: "success",
            duration: 10000
          });
          window.location.href = process.env.VUE_APP_BASEURL + res.data;
        }
        else {
          this.querys = { ...res.data };
        }
      });
    },
    submit() {
      let that = this;

      this.$refs.forms.validate((valid) => {
        if (!valid) return;

        submitUser(this.forms).then((res) => {
          if (res.code === 200) {
            that.$message({
              type: "success",
              message: res.content,
            });

            that.$refs.dialog.toggle();
            that.fetchs();
          }
        });
      });
    },
    currHandler(row) {
      this.currRow = row;
    },
    pageHandler(page) {
      this.querys.page = page;
      this.fetchs();
    },
    sizeHandler(rows) {
      this.querys.rows = rows;
      this.fetchs();
    },
    sortHandler(order) {
      this.querys.sidx = order.prop;
      this.querys.sord = order.order;
      this.fetchs();
    },

    reset() {
      if (this.currRow) {
        this.$refs.resetDialog.toggle();
      } else {
        this.$message({
          type: "info",
          message: "请选择对应数据",
        });
      }
    },
    resetPwdEvent() {
      this.$refs.resetPwdDialogRef.resetPwd();
    },

    fetchRoleData(globalId) {
      var that = this;
      fetchRelationByGlobalId('user-role', globalId).then((res) => {
        that.checkedKeys = res.data;
        that.$refs.roleSelect.setCheckedKeys(res.data);
      });
    },
    openRole(row) {
      this.forms = { ...row };
      this.fetchRoleData(this.forms.id);
      this.$refs.roleDialog.toggle();
    },

    submitRole() {
      let checkedSelectIds = this.$refs.roleSelect.getSelectIds();

      submitRelationByGlobalId(checkedSelectIds, 'user-role', this.forms.id).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: res.content,
          });
        }
      });
    },

    fetchCompanyPowerData(globalId) {
      fetchUserDataRange(globalId).then((res) => {
        const ranges = Array.isArray(res.data) ? res.data : [];
        this.companyCheckedKeys = ranges
          .filter(item => item.category === 'Company')
          .map(item => item.objectID)
          .filter(Boolean);
        this.$nextTick(() => {
          this.$refs.companyPowerTree.setCheckedKeys(this.companyCheckedKeys);
        });
      });
    },
    openCompanyPower(row) {
      const rowData = row || this.currRow;
      if (!rowData) {
        this.$message({ type: "error", message: "请先选择用户", });
        return;
      }

      this.companyPowerId = rowData.id;
      this.companyTreeData = this.companys || [];

      const openDialog = () => {
        this.fetchCompanyPowerData(this.companyPowerId);
        this.$refs.companyPowerDialog.toggle();
      };

      if (this.companyTreeData.length > 0) {
        openDialog();
        return;
      }

      this.$kaung.companys().then((res) => {
        this.companys = res;
        this.companyTreeData = res || [];
        openDialog();
      });
    },
    submitCompanyPower() {
      this.$nextTick(() => {
        const checkedCompanyIds = this.$refs.companyPowerTree.getCheckedKeys(false);
        submitUserDataRange(checkedCompanyIds, this.companyPowerId).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: res.content,
            });
          }
        });
      });
    },


    companyChange(companyID) {
      if (!companyID) return;

      var that = this;
      this.$kaung.departments(companyID).then((res) => {
        that.departments = res;
      });
    },

    // 重置安全密码
    resetSecondaryPassword() {
      if (!this.currRow) {
        this.$message({
          type: "info",
          message: "请选择对应数据",
        });
        return;
      }
      
      // 重置表单
      this.secondaryPasswordForm = {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      };
      
      this.secondaryPasswordDialog = true;
    },

    // 确认重置安全密码
    handleResetSecondaryPassword() {
      this.$refs.secondaryPasswordFormRef.validate((valid) => {
        if (!valid) return;

        this.submittingSecondaryPassword = true;
        
        // 使用MD5加密旧密码和新密码
        const encryptedOldPassword = this.$util.md5Encrypt(this.secondaryPasswordForm.oldPassword);
        const encryptedNewPassword = this.$util.md5Encrypt(this.secondaryPasswordForm.newPassword);
        
        this.$kaung.fetch({
          url: '/BaseUser/ResetSecondaryPassword',
          method: 'get',
          params: {
            id: this.currRow.id,
            oldpassword: encryptedOldPassword,
            newpassword: encryptedNewPassword
          }
        }).then((res) => {
          this.$message({ message: res.content, type: res.type });
          if (res.code === 200) {
            // 关闭对话框
            this.secondaryPasswordDialog = false;
            // 重置表单
            this.secondaryPasswordForm = {
              oldPassword: '',
              newPassword: '',
              confirmNewPassword: ''
            };
            this.$refs.secondaryPasswordFormRef.resetFields();
          }
        }).finally(() => {
          this.submittingSecondaryPassword = false;
        });
      });
    }
  },
};
</script>
<style scoped>
.el-radio {
  margin-right: 10px;
}
</style>


